import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "closet-clothing-detail" }
const _hoisted_2 = {
  key: 0,
  class: "clothing-layout"
}
const _hoisted_3 = { class: "clothing-detail-left" }
const _hoisted_4 = { class: "detail-section" }
const _hoisted_5 = { class: "detail-header" }
const _hoisted_6 = { class: "detail-title-row" }
const _hoisted_7 = { class: "badge category" }
const _hoisted_8 = { class: "detail-brand" }
const _hoisted_9 = { class: "detail-product" }
const _hoisted_10 = { class: "detail-actions" }
const _hoisted_11 = { class: "detail-info-grid" }
const _hoisted_12 = {
  key: 0,
  class: "info-item"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "소분류", -1)
const _hoisted_14 = { class: "info-value" }
const _hoisted_15 = {
  key: 1,
  class: "info-item"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "표기 사이즈", -1)
const _hoisted_17 = { class: "info-value size-badge" }
const _hoisted_18 = {
  key: 2,
  class: "info-item"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "구매일", -1)
const _hoisted_20 = { class: "info-value" }
const _hoisted_21 = {
  key: 3,
  class: "info-item"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "만족도", -1)
const _hoisted_23 = { class: "info-value" }
const _hoisted_24 = {
  key: 4,
  class: "info-item"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "핏 평가", -1)
const _hoisted_26 = {
  key: 0,
  class: "measure-detail"
}
const _hoisted_27 = { class: "measure-detail-header" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "measure-detail-title" }, "실측 치수", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "sep" }, "/", -1)
const _hoisted_30 = { class: "measure-tags" }
const _hoisted_31 = { class: "measure-label" }
const _hoisted_32 = { class: "measure-value" }
const _hoisted_33 = {
  key: 1,
  class: "memo-section"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "memo-title" }, "메모", -1)
const _hoisted_35 = { class: "memo-content" }
const _hoisted_36 = { class: "detail-footer" }
const _hoisted_37 = {
  key: 0,
  class: "clothing-svg-section"
}
const _hoisted_38 = { class: "svg-card" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "svg-title" }, "의류 치수 다이어그램", -1)
const _hoisted_40 = { class: "svg-container" }
const _hoisted_41 = {
  key: 0,
  viewBox: "0 0 300 360",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "dtTopGrad",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      "stop-color": "#dce8f5"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      "stop-color": "#eef4fc"
    })
  ])
], -1)
const _hoisted_43 = ["d"]
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["x1", "y1", "x2", "y2"]
const _hoisted_46 = ["x1", "y1", "x2", "y2"]
const _hoisted_47 = ["x1", "y1", "x2", "y2"]
const _hoisted_48 = ["x", "y"]
const _hoisted_49 = ["x", "y"]
const _hoisted_50 = { key: 1 }
const _hoisted_51 = ["x1", "y1", "x2", "y2"]
const _hoisted_52 = ["x1", "y1", "x2", "y2"]
const _hoisted_53 = ["x1", "y1", "x2", "y2"]
const _hoisted_54 = ["y"]
const _hoisted_55 = ["y"]
const _hoisted_56 = { key: 2 }
const _hoisted_57 = ["x1", "y1", "x2", "y2"]
const _hoisted_58 = ["x1", "y1", "x2", "y2"]
const _hoisted_59 = ["x1", "y1", "x2", "y2"]
const _hoisted_60 = ["x", "y"]
const _hoisted_61 = ["x", "y"]
const _hoisted_62 = { key: 3 }
const _hoisted_63 = ["x1", "y1", "x2", "y2"]
const _hoisted_64 = ["x", "y"]
const _hoisted_65 = ["x", "y"]
const _hoisted_66 = { key: 4 }
const _hoisted_67 = ["x1", "y1", "x2", "y2"]
const _hoisted_68 = ["x1", "y1", "x2", "y2"]
const _hoisted_69 = ["x1", "y1", "x2", "y2"]
const _hoisted_70 = ["y"]
const _hoisted_71 = ["y"]
const _hoisted_72 = { key: 5 }
const _hoisted_73 = ["x1", "y1", "x2", "y2"]
const _hoisted_74 = ["cx", "cy"]
const _hoisted_75 = ["cx", "cy"]
const _hoisted_76 = ["x", "y"]
const _hoisted_77 = ["x", "y"]
const _hoisted_78 = {
  key: 1,
  viewBox: "0 0 300 400",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "dtBtmGrad",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      "stop-color": "#dce8f5"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      "stop-color": "#eef4fc"
    })
  ])
], -1)
const _hoisted_80 = ["d"]
const _hoisted_81 = { key: 0 }
const _hoisted_82 = ["x1", "y1", "x2", "y2"]
const _hoisted_83 = ["x1", "y1", "x2", "y2"]
const _hoisted_84 = ["x1", "y1", "x2", "y2"]
const _hoisted_85 = ["x", "y"]
const _hoisted_86 = ["x", "y"]
const _hoisted_87 = { key: 1 }
const _hoisted_88 = ["x1", "y1", "x2", "y2"]
const _hoisted_89 = ["x1", "y1", "x2", "y2"]
const _hoisted_90 = ["x1", "y1", "x2", "y2"]
const _hoisted_91 = ["y"]
const _hoisted_92 = ["y"]
const _hoisted_93 = { key: 2 }
const _hoisted_94 = ["x1", "y1", "x2", "y2"]
const _hoisted_95 = ["x1", "y1", "x2", "y2"]
const _hoisted_96 = ["x1", "y1", "x2", "y2"]
const _hoisted_97 = ["x", "y"]
const _hoisted_98 = ["x", "y"]
const _hoisted_99 = { key: 3 }
const _hoisted_100 = ["x1", "y1", "x2", "y2"]
const _hoisted_101 = ["x1", "y1", "x2", "y2"]
const _hoisted_102 = ["x1", "y1", "x2", "y2"]
const _hoisted_103 = ["x", "y"]
const _hoisted_104 = ["x", "y"]
const _hoisted_105 = { key: 4 }
const _hoisted_106 = ["x1", "y1", "x2", "y2"]
const _hoisted_107 = ["x1", "y1", "x2", "y2"]
const _hoisted_108 = ["x1", "y1", "x2", "y2"]
const _hoisted_109 = ["x", "y"]
const _hoisted_110 = ["x", "y"]
const _hoisted_111 = { key: 5 }
const _hoisted_112 = ["x1", "y1", "x2", "y2"]
const _hoisted_113 = ["x1", "y1", "x2", "y2"]
const _hoisted_114 = ["x1", "y1", "x2", "y2"]
const _hoisted_115 = ["x", "y"]
const _hoisted_116 = ["x", "y"]
const _hoisted_117 = {
  key: 2,
  viewBox: "0 0 300 400",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_118 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "dtOpGrad",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      "stop-color": "#f0dce8"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      "stop-color": "#fceef4"
    })
  ])
], -1)
const _hoisted_119 = ["d"]
const _hoisted_120 = { key: 0 }
const _hoisted_121 = ["x1", "y1", "x2", "y2"]
const _hoisted_122 = ["x1", "y1", "x2", "y2"]
const _hoisted_123 = ["x1", "y1", "x2", "y2"]
const _hoisted_124 = ["x", "y"]
const _hoisted_125 = ["x", "y"]
const _hoisted_126 = { key: 1 }
const _hoisted_127 = ["x1", "y1", "x2", "y2"]
const _hoisted_128 = ["x1", "y1", "x2", "y2"]
const _hoisted_129 = ["x1", "y1", "x2", "y2"]
const _hoisted_130 = ["y"]
const _hoisted_131 = ["y"]
const _hoisted_132 = { key: 2 }
const _hoisted_133 = ["x1", "y1", "x2", "y2"]
const _hoisted_134 = ["x", "y"]
const _hoisted_135 = ["x", "y"]
const _hoisted_136 = { key: 3 }
const _hoisted_137 = ["x1", "y1", "x2", "y2"]
const _hoisted_138 = ["x", "y"]
const _hoisted_139 = ["x", "y"]
const _hoisted_140 = { key: 4 }
const _hoisted_141 = ["x1", "y1", "x2", "y2"]
const _hoisted_142 = ["x", "y"]
const _hoisted_143 = ["x", "y"]
const _hoisted_144 = { key: 5 }
const _hoisted_145 = ["x1", "y1", "x2", "y2"]
const _hoisted_146 = ["x", "y"]
const _hoisted_147 = ["x", "y"]
const _hoisted_148 = {
  key: 3,
  viewBox: "0 0 300 200",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_149 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "dtShoeGrad",
    x1: "0",
    y1: "0",
    x2: "1",
    y2: "0"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      "stop-color": "#e8e0d4"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      "stop-color": "#f5f0e8"
    })
  ])
], -1)
const _hoisted_150 = ["d"]
const _hoisted_151 = { key: 0 }
const _hoisted_152 = ["x1", "y1", "x2", "y2"]
const _hoisted_153 = ["x1", "y1", "x2", "y2"]
const _hoisted_154 = ["x1", "y1", "x2", "y2"]
const _hoisted_155 = ["x", "y"]
const _hoisted_156 = ["x", "y"]
const _hoisted_157 = { key: 1 }
const _hoisted_158 = ["x1", "y1", "x2", "y2"]
const _hoisted_159 = ["x1", "y1", "x2", "y2"]
const _hoisted_160 = ["x1", "y1", "x2", "y2"]
const _hoisted_161 = ["x", "y"]
const _hoisted_162 = ["x", "y"]
const _hoisted_163 = {
  key: 1,
  class: "loading-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.clothing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getCategoryLabel(_ctx.clothing.category)), 1),
                  _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.clothing.brandName), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.clothing.productName || _ctx.clothing.subCategory), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    class: "btn-edit",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToEdit && _ctx.goToEdit(...args)))
                  }, "수정"),
                  _createElementVNode("button", {
                    class: "btn-delete",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDelete && _ctx.handleDelete(...args)))
                  }, "삭제")
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_ctx.clothing.subCategory)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.clothing.subCategory), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.clothing.labeledSize)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.clothing.labeledSize), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.clothing.purchaseDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatDate(_ctx.clothing.purchaseDate)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.clothing.satisfaction)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("span", _hoisted_23, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (s) => {
                          return _createElementVNode("span", {
                            key: s,
                            class: _normalizeClass(["star-sm", { active: s <= _ctx.clothing.satisfaction }])
                          }, "★", 2)
                        }), 64))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.clothing.fitFeedback)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("span", {
                        class: _normalizeClass(["fit-chip", _ctx.fitClass(_ctx.clothing.fitFeedback)])
                      }, _toDisplayString(_ctx.getFitFeedbackLabel(_ctx.clothing.fitFeedback)), 3)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.clothing.measurements && Object.keys(_ctx.clothing.measurements).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("button", {
                        class: "unit-toggle",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleUnit && _ctx.toggleUnit(...args)))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass({ on: !_ctx.toInch })
                        }, "cm", 2),
                        _hoisted_29,
                        _createElementVNode("span", {
                          class: _normalizeClass({ on: _ctx.toInch })
                        }, "in", 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clothing.measurements, (val, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: "measure-item"
                        }, [
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.getMeasureLabel(_ctx.clothing.category, String(key))), 1),
                          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.dispMeasureVal(_ctx.clothing.category, String(key), Number(val))) + _toDisplayString(_ctx.dispMeasureUnit(_ctx.clothing.category, String(key))), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.clothing.memo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.clothing.memo), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("button", {
                  class: "btn-back",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToList && _ctx.goToList(...args)))
                }, "목록으로")
              ])
            ])
          ]),
          (_ctx.hasMeasurements)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, [
                    (_ctx.svgCategory === 'TOP')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("path", {
                            d: _ctx.topSvgPath,
                            fill: "url(#dtTopGrad)",
                            stroke: "#4a90d9",
                            "stroke-width": "2",
                            "stroke-linejoin": "round"
                          }, null, 8, _hoisted_43),
                          (_ctx.ms.total_length)
                            ? (_openBlock(), _createElementBlock("g", _hoisted_44, [
                                _createElementVNode("line", {
                                  x1: _ctx.topCoords.leftEdge - 20,
                                  y1: _ctx.topCoords.topY,
                                  x2: _ctx.topCoords.leftEdge - 20,
                                  y2: _ctx.topCoords.bottomY,
                                  stroke: "#888",
                                  "stroke-width": "0.8",
                                  "stroke-dasharray": "4,2"
                                }, null, 8, _hoisted_45),
                                _createElementVNode("line", {
                                  x1: _ctx.topCoords.leftEdge - 24,
                                  y1: _ctx.topCoords.topY,
                                  x2: _ctx.topCoords.leftEdge - 16,
                                  y2: _ctx.topCoords.topY,
                                  stroke: "#888",
                                  "stroke-width": "1"
                                }, null, 8, _hoisted_46),
                                _createElementVNode("line", {
                                  x1: _ctx.topCoords.leftEdge - 24,
                                  y1: _ctx.topCoords.bottomY,
                                  x2: _ctx.topCoords.leftEdge - 16,
                                  y2: _ctx.topCoords.bottomY,
                                  stroke: "#888",
                                  "stroke-width": "1"
                                }, null, 8, _hoisted_47),
                                _createElementVNode("rect", {
                                  x: _ctx.topCoords.leftEdge - 50,
                                  y: (_ctx.topCoords.topY + _ctx.topCoords.bottomY) / 2 - 8,
                                  width: "56",
                                  height: "16",
                                  rx: "3",
                                  fill: "#fff",
                                  stroke: "#ddd",
                                  "stroke-width": "0.5"
                                }, null, 8, _hoisted_48),
                                _createElementVNode("text", {
                                  x: _ctx.topCoords.leftEdge - 22,
                                  y: (_ctx.topCoords.topY + _ctx.topCoords.bottomY) / 2 + 4,
                                  "text-anchor": "middle",
                                  class: "svg-measure-label"
                                }, "총장 " + _toDisplayString(_ctx.dcm(_ctx.ms.total_length)) + _toDisplayString(_ctx.lenU), 9, _hoisted_49)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.ms.shoulder_width)
                            ? (_openBlock(), _createElementBlock("g", _hoisted_50, [
                                _createElementVNode("line", {
                                  x1: _ctx.topCoords.shoulderL,
                                  y1: _ctx.topCoords.topY - 16,
                                  x2: _ctx.topCoords.shoulderR,
                                  y2: _ctx.topCoords.topY - 16,
                                  stroke: "#e74c3c",
                                  "stroke-width": "0.8",
                                  "stroke-dasharray": "4,2"
                                }, null, 8, _hoisted_51),
                                _createElementVNode("line", {
                                  x1: _ctx.topCoords.shoulderL,
                                  y1: _ctx.topCoords.topY - 20,
                                  x2: _ctx.topCoords.shoulderL,
                                  y2: _ctx.topCoords.topY - 12,
                                  stroke: "#e74c3c",
                                  "stroke-width": "1"
                                }, null, 8, _hoisted_52),
                                _createElementVNode("line", {
                                  x1: _ctx.topCoords.shoulderR,
                                  y1: _ctx.topCoords.topY - 20,
                                  x2: _ctx.topCoords.shoulderR,
                                  y2: _ctx.topCoords.topY - 12,
                                  stroke: "#e74c3c",
                                  "stroke-width": "1"
                                }, null, 8, _hoisted_53),
                                _createElementVNode("rect", {
                                  x: 150 - 34,
                                  y: _ctx.topCoords.topY - 34,
                                  width: "68",
                                  height: "16",
                                  rx: "3",
                                  fill: "#fff",
                                  stroke: "#f0c0c0",
                                  "stroke-width": "0.5"
                                }, null, 8, _hoisted_54),
                                _createElementVNode("text", {
                                  x: "150",
                                  y: _ctx.topCoords.topY - 23,
                                  "text-anchor": "middle",
                                  class: "svg-measure-label red"
                                }, "어깨 " + _toDisplayString(_ctx.dcm(_ctx.ms.shoulder_width)) + _toDisplayString(_ctx.lenU), 9, _hoisted_55)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.ms.chest_width)
                            ? (_openBlock(), _createElementBlock("g", _hoisted_56, [
                                _createElementVNode("line", {
                                  x1: _ctx.topCoords.chestL,
                                  y1: _ctx.topCoords.chestY,
                                  x2: _ctx.topCoords.chestR,
                                  y2: _ctx.topCoords.chestY,
                                  stroke: "#e74c3c",
                                  "stroke-width": "0.8",
                                  "stroke-dasharray": "4,2"
                                }, null, 8, _hoisted_57),
                                _createElementVNode("line", {
                                  x1: _ctx.topCoords.chestL,
                                  y1: _ctx.topCoords.chestY - 4,
                                  x2: _ctx.topCoords.chestL,
                                  y2: _ctx.topCoords.chestY + 4,
                                  stroke: "#e74c3c",
                                  "stroke-width": "1"
                                }, null, 8, _hoisted_58),
                                _createElementVNode("line", {
                                  x1: _ctx.topCoords.chestR,
                                  y1: _ctx.topCoords.chestY - 4,
                                  x2: _ctx.topCoords.chestR,
                                  y2: _ctx.topCoords.chestY + 4,
                                  stroke: "#e74c3c",
                                  "stroke-width": "1"
                                }, null, 8, _hoisted_59),
                                _createElementVNode("rect", {
                                  x: (_ctx.topCoords.chestL + _ctx.topCoords.chestR) / 2 - 34,
                                  y: _ctx.topCoords.chestY + 8,
                                  width: "68",
                                  height: "16",
                                  rx: "3",
                                  fill: "#fff",
                                  stroke: "#f0c0c0",
                                  "stroke-width": "0.5"
                                }, null, 8, _hoisted_60),
                                _createElementVNode("text", {
                                  x: (_ctx.topCoords.chestL + _ctx.topCoords.chestR) / 2,
                                  y: _ctx.topCoords.chestY + 20,
                                  "text-anchor": "middle",
                                  class: "svg-measure-label red"
                                }, "가슴 " + _toDisplayString(_ctx.dcm(_ctx.ms.chest_width)) + _toDisplayString(_ctx.lenU), 9, _hoisted_61)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.ms.sleeve_length)
                            ? (_openBlock(), _createElementBlock("g", _hoisted_62, [
                                _createElementVNode("line", {
                                  x1: _ctx.topCoords.shoulderR,
                                  y1: _ctx.topCoords.topY,
                                  x2: _ctx.topCoords.sleeveEndX,
                                  y2: _ctx.topCoords.sleeveEndY,
                                  stroke: "#3498db",
                                  "stroke-width": "0.8",
                                  "stroke-dasharray": "4,2"
                                }, null, 8, _hoisted_63),
                                _createElementVNode("rect", {
                                  x: (_ctx.topCoords.shoulderR + _ctx.topCoords.sleeveEndX) / 2 - 34,
                                  y: (_ctx.topCoords.topY + _ctx.topCoords.sleeveEndY) / 2 - 18,
                                  width: "68",
                                  height: "16",
                                  rx: "3",
                                  fill: "#fff",
                                  stroke: "#c0d8f0",
                                  "stroke-width": "0.5"
                                }, null, 8, _hoisted_64),
                                _createElementVNode("text", {
                                  x: (_ctx.topCoords.shoulderR + _ctx.topCoords.sleeveEndX) / 2,
                                  y: (_ctx.topCoords.topY + _ctx.topCoords.sleeveEndY) / 2 - 6,
                                  "text-anchor": "middle",
                                  class: "svg-measure-label blue"
                                }, "소매 " + _toDisplayString(_ctx.dcm(_ctx.ms.sleeve_length)) + _toDisplayString(_ctx.lenU), 9, _hoisted_65)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.ms.hem_width)
                            ? (_openBlock(), _createElementBlock("g", _hoisted_66, [
                                _createElementVNode("line", {
                                  x1: _ctx.topCoords.hemL,
                                  y1: _ctx.topCoords.bottomY + 12,
                                  x2: _ctx.topCoords.hemR,
                                  y2: _ctx.topCoords.bottomY + 12,
                                  stroke: "#27ae60",
                                  "stroke-width": "0.8",
                                  "stroke-dasharray": "4,2"
                                }, null, 8, _hoisted_67),
                                _createElementVNode("line", {
                                  x1: _ctx.topCoords.hemL,
                                  y1: _ctx.topCoords.bottomY + 8,
                                  x2: _ctx.topCoords.hemL,
                                  y2: _ctx.topCoords.bottomY + 16,
                                  stroke: "#27ae60",
                                  "stroke-width": "1"
                                }, null, 8, _hoisted_68),
                                _createElementVNode("line", {
                                  x1: _ctx.topCoords.hemR,
                                  y1: _ctx.topCoords.bottomY + 8,
                                  x2: _ctx.topCoords.hemR,
                                  y2: _ctx.topCoords.bottomY + 16,
                                  stroke: "#27ae60",
                                  "stroke-width": "1"
                                }, null, 8, _hoisted_69),
                                _createElementVNode("rect", {
                                  x: 150 - 30,
                                  y: _ctx.topCoords.bottomY + 18,
                                  width: "60",
                                  height: "16",
                                  rx: "3",
                                  fill: "#fff",
                                  stroke: "#b0d8b0",
                                  "stroke-width": "0.5"
                                }, null, 8, _hoisted_70),
                                _createElementVNode("text", {
                                  x: "150",
                                  y: _ctx.topCoords.bottomY + 30,
                                  "text-anchor": "middle",
                                  class: "svg-measure-label green"
                                }, "밑단 " + _toDisplayString(_ctx.dcm(_ctx.ms.hem_width)) + _toDisplayString(_ctx.lenU), 9, _hoisted_71)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.ms.armhole)
                            ? (_openBlock(), _createElementBlock("g", _hoisted_72, [
                                _createElementVNode("line", {
                                  x1: _ctx.topCoords.shoulderR,
                                  y1: _ctx.topCoords.topY,
                                  x2: _ctx.topCoords.rArmX,
                                  y2: _ctx.topCoords.rArmY,
                                  stroke: "#8e44ad",
                                  "stroke-width": "0.8",
                                  "stroke-dasharray": "4,2"
                                }, null, 8, _hoisted_73),
                                _createElementVNode("circle", {
                                  cx: _ctx.topCoords.shoulderR,
                                  cy: _ctx.topCoords.topY,
                                  r: "2",
                                  fill: "#8e44ad"
                                }, null, 8, _hoisted_74),
                                _createElementVNode("circle", {
                                  cx: _ctx.topCoords.rArmX,
                                  cy: _ctx.topCoords.rArmY,
                                  r: "2",
                                  fill: "#8e44ad"
                                }, null, 8, _hoisted_75),
                                _createElementVNode("rect", {
                                  x: _ctx.topCoords.shoulderR - 68,
                                  y: (_ctx.topCoords.topY + _ctx.topCoords.rArmY) / 2 - 8,
                                  width: "62",
                                  height: "16",
                                  rx: "3",
                                  fill: "#fff",
                                  stroke: "#d8c0f0",
                                  "stroke-width": "0.5"
                                }, null, 8, _hoisted_76),
                                _createElementVNode("text", {
                                  x: _ctx.topCoords.shoulderR - 37,
                                  y: (_ctx.topCoords.topY + _ctx.topCoords.rArmY) / 2 + 4,
                                  "text-anchor": "middle",
                                  class: "svg-measure-label purple"
                                }, "암홀 " + _toDisplayString(_ctx.dcm(_ctx.ms.armhole)) + _toDisplayString(_ctx.lenU), 9, _hoisted_77)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_ctx.svgCategory === 'BOTTOM')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_78, [
                            _hoisted_79,
                            _createElementVNode("path", {
                              d: _ctx.bottomSvgPath,
                              fill: "url(#dtBtmGrad)",
                              stroke: "#4a90d9",
                              "stroke-width": "2",
                              "stroke-linejoin": "round"
                            }, null, 8, _hoisted_80),
                            (_ctx.ms.total_length)
                              ? (_openBlock(), _createElementBlock("g", _hoisted_81, [
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.leftEdge - 20,
                                    y1: _ctx.btmCoords.topY,
                                    x2: _ctx.btmCoords.leftEdge - 20,
                                    y2: _ctx.btmCoords.bottomY,
                                    stroke: "#888",
                                    "stroke-width": "0.8",
                                    "stroke-dasharray": "4,2"
                                  }, null, 8, _hoisted_82),
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.leftEdge - 24,
                                    y1: _ctx.btmCoords.topY,
                                    x2: _ctx.btmCoords.leftEdge - 16,
                                    y2: _ctx.btmCoords.topY,
                                    stroke: "#888",
                                    "stroke-width": "1"
                                  }, null, 8, _hoisted_83),
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.leftEdge - 24,
                                    y1: _ctx.btmCoords.bottomY,
                                    x2: _ctx.btmCoords.leftEdge - 16,
                                    y2: _ctx.btmCoords.bottomY,
                                    stroke: "#888",
                                    "stroke-width": "1"
                                  }, null, 8, _hoisted_84),
                                  _createElementVNode("rect", {
                                    x: _ctx.btmCoords.leftEdge - 50,
                                    y: (_ctx.btmCoords.topY + _ctx.btmCoords.bottomY) / 2 - 8,
                                    width: "56",
                                    height: "16",
                                    rx: "3",
                                    fill: "#fff",
                                    stroke: "#ddd",
                                    "stroke-width": "0.5"
                                  }, null, 8, _hoisted_85),
                                  _createElementVNode("text", {
                                    x: _ctx.btmCoords.leftEdge - 22,
                                    y: (_ctx.btmCoords.topY + _ctx.btmCoords.bottomY) / 2 + 4,
                                    "text-anchor": "middle",
                                    class: "svg-measure-label"
                                  }, "총장 " + _toDisplayString(_ctx.dcm(_ctx.ms.total_length)) + _toDisplayString(_ctx.lenU), 9, _hoisted_86)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.ms.waist_width)
                              ? (_openBlock(), _createElementBlock("g", _hoisted_87, [
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.waistL,
                                    y1: _ctx.btmCoords.topY - 14,
                                    x2: _ctx.btmCoords.waistR,
                                    y2: _ctx.btmCoords.topY - 14,
                                    stroke: "#e74c3c",
                                    "stroke-width": "0.8",
                                    "stroke-dasharray": "4,2"
                                  }, null, 8, _hoisted_88),
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.waistL,
                                    y1: _ctx.btmCoords.topY - 18,
                                    x2: _ctx.btmCoords.waistL,
                                    y2: _ctx.btmCoords.topY - 10,
                                    stroke: "#e74c3c",
                                    "stroke-width": "1"
                                  }, null, 8, _hoisted_89),
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.waistR,
                                    y1: _ctx.btmCoords.topY - 18,
                                    x2: _ctx.btmCoords.waistR,
                                    y2: _ctx.btmCoords.topY - 10,
                                    stroke: "#e74c3c",
                                    "stroke-width": "1"
                                  }, null, 8, _hoisted_90),
                                  _createElementVNode("rect", {
                                    x: 150 - 34,
                                    y: _ctx.btmCoords.topY - 32,
                                    width: "68",
                                    height: "16",
                                    rx: "3",
                                    fill: "#fff",
                                    stroke: "#f0c0c0",
                                    "stroke-width": "0.5"
                                  }, null, 8, _hoisted_91),
                                  _createElementVNode("text", {
                                    x: "150",
                                    y: _ctx.btmCoords.topY - 21,
                                    "text-anchor": "middle",
                                    class: "svg-measure-label red"
                                  }, "허리 " + _toDisplayString(_ctx.dcm(_ctx.ms.waist_width)) + _toDisplayString(_ctx.lenU), 9, _hoisted_92)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.ms.hip_width)
                              ? (_openBlock(), _createElementBlock("g", _hoisted_93, [
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.hipL,
                                    y1: _ctx.btmCoords.hipY,
                                    x2: _ctx.btmCoords.hipR,
                                    y2: _ctx.btmCoords.hipY,
                                    stroke: "#e74c3c",
                                    "stroke-width": "0.8",
                                    "stroke-dasharray": "4,2"
                                  }, null, 8, _hoisted_94),
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.hipL,
                                    y1: _ctx.btmCoords.hipY - 4,
                                    x2: _ctx.btmCoords.hipL,
                                    y2: _ctx.btmCoords.hipY + 4,
                                    stroke: "#e74c3c",
                                    "stroke-width": "1"
                                  }, null, 8, _hoisted_95),
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.hipR,
                                    y1: _ctx.btmCoords.hipY - 4,
                                    x2: _ctx.btmCoords.hipR,
                                    y2: _ctx.btmCoords.hipY + 4,
                                    stroke: "#e74c3c",
                                    "stroke-width": "1"
                                  }, null, 8, _hoisted_96),
                                  _createElementVNode("rect", {
                                    x: _ctx.btmCoords.hipR + 6,
                                    y: _ctx.btmCoords.hipY - 8,
                                    width: "68",
                                    height: "16",
                                    rx: "3",
                                    fill: "#fff",
                                    stroke: "#f0c0c0",
                                    "stroke-width": "0.5"
                                  }, null, 8, _hoisted_97),
                                  _createElementVNode("text", {
                                    x: _ctx.btmCoords.hipR + 40,
                                    y: _ctx.btmCoords.hipY + 4,
                                    "text-anchor": "middle",
                                    class: "svg-measure-label red"
                                  }, "엉덩이 " + _toDisplayString(_ctx.dcm(_ctx.ms.hip_width)) + _toDisplayString(_ctx.lenU), 9, _hoisted_98)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.ms.thigh_width)
                              ? (_openBlock(), _createElementBlock("g", _hoisted_99, [
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.thighL,
                                    y1: _ctx.btmCoords.thighY,
                                    x2: _ctx.btmCoords.thighMid,
                                    y2: _ctx.btmCoords.thighY,
                                    stroke: "#3498db",
                                    "stroke-width": "0.8",
                                    "stroke-dasharray": "4,2"
                                  }, null, 8, _hoisted_100),
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.thighL,
                                    y1: _ctx.btmCoords.thighY - 4,
                                    x2: _ctx.btmCoords.thighL,
                                    y2: _ctx.btmCoords.thighY + 4,
                                    stroke: "#3498db",
                                    "stroke-width": "1"
                                  }, null, 8, _hoisted_101),
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.thighMid,
                                    y1: _ctx.btmCoords.thighY - 4,
                                    x2: _ctx.btmCoords.thighMid,
                                    y2: _ctx.btmCoords.thighY + 4,
                                    stroke: "#3498db",
                                    "stroke-width": "1"
                                  }, null, 8, _hoisted_102),
                                  _createElementVNode("rect", {
                                    x: _ctx.btmCoords.thighL - 4,
                                    y: _ctx.btmCoords.thighY + 6,
                                    width: "72",
                                    height: "16",
                                    rx: "3",
                                    fill: "#fff",
                                    stroke: "#c0d8f0",
                                    "stroke-width": "0.5"
                                  }, null, 8, _hoisted_103),
                                  _createElementVNode("text", {
                                    x: _ctx.btmCoords.thighL + 32,
                                    y: _ctx.btmCoords.thighY + 18,
                                    "text-anchor": "middle",
                                    class: "svg-measure-label blue"
                                  }, "허벅지 " + _toDisplayString(_ctx.dcm(_ctx.ms.thigh_width)) + _toDisplayString(_ctx.lenU), 9, _hoisted_104)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.ms.rise)
                              ? (_openBlock(), _createElementBlock("g", _hoisted_105, [
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.waistR + 16,
                                    y1: _ctx.btmCoords.topY,
                                    x2: _ctx.btmCoords.waistR + 16,
                                    y2: _ctx.btmCoords.crotchY,
                                    stroke: "#27ae60",
                                    "stroke-width": "0.8",
                                    "stroke-dasharray": "4,2"
                                  }, null, 8, _hoisted_106),
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.waistR + 12,
                                    y1: _ctx.btmCoords.topY,
                                    x2: _ctx.btmCoords.waistR + 20,
                                    y2: _ctx.btmCoords.topY,
                                    stroke: "#27ae60",
                                    "stroke-width": "1"
                                  }, null, 8, _hoisted_107),
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.waistR + 12,
                                    y1: _ctx.btmCoords.crotchY,
                                    x2: _ctx.btmCoords.waistR + 20,
                                    y2: _ctx.btmCoords.crotchY,
                                    stroke: "#27ae60",
                                    "stroke-width": "1"
                                  }, null, 8, _hoisted_108),
                                  _createElementVNode("rect", {
                                    x: _ctx.btmCoords.waistR + 22,
                                    y: (_ctx.btmCoords.topY + _ctx.btmCoords.crotchY) / 2 - 8,
                                    width: "56",
                                    height: "16",
                                    rx: "3",
                                    fill: "#fff",
                                    stroke: "#b0d8b0",
                                    "stroke-width": "0.5"
                                  }, null, 8, _hoisted_109),
                                  _createElementVNode("text", {
                                    x: _ctx.btmCoords.waistR + 50,
                                    y: (_ctx.btmCoords.topY + _ctx.btmCoords.crotchY) / 2 + 4,
                                    "text-anchor": "middle",
                                    class: "svg-measure-label green"
                                  }, "밑위 " + _toDisplayString(_ctx.dcm(_ctx.ms.rise)) + _toDisplayString(_ctx.lenU), 9, _hoisted_110)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.ms.hem_width)
                              ? (_openBlock(), _createElementBlock("g", _hoisted_111, [
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.hemL,
                                    y1: _ctx.btmCoords.bottomY + 12,
                                    x2: _ctx.btmCoords.hemMid,
                                    y2: _ctx.btmCoords.bottomY + 12,
                                    stroke: "#27ae60",
                                    "stroke-width": "0.8",
                                    "stroke-dasharray": "4,2"
                                  }, null, 8, _hoisted_112),
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.hemL,
                                    y1: _ctx.btmCoords.bottomY + 8,
                                    x2: _ctx.btmCoords.hemL,
                                    y2: _ctx.btmCoords.bottomY + 16,
                                    stroke: "#27ae60",
                                    "stroke-width": "1"
                                  }, null, 8, _hoisted_113),
                                  _createElementVNode("line", {
                                    x1: _ctx.btmCoords.hemMid,
                                    y1: _ctx.btmCoords.bottomY + 8,
                                    x2: _ctx.btmCoords.hemMid,
                                    y2: _ctx.btmCoords.bottomY + 16,
                                    stroke: "#27ae60",
                                    "stroke-width": "1"
                                  }, null, 8, _hoisted_114),
                                  _createElementVNode("rect", {
                                    x: _ctx.btmCoords.hemL - 4,
                                    y: _ctx.btmCoords.bottomY + 20,
                                    width: "60",
                                    height: "16",
                                    rx: "3",
                                    fill: "#fff",
                                    stroke: "#b0d8b0",
                                    "stroke-width": "0.5"
                                  }, null, 8, _hoisted_115),
                                  _createElementVNode("text", {
                                    x: _ctx.btmCoords.hemL + 26,
                                    y: _ctx.btmCoords.bottomY + 32,
                                    "text-anchor": "middle",
                                    class: "svg-measure-label green"
                                  }, "밑단 " + _toDisplayString(_ctx.dcm(_ctx.ms.hem_width)) + _toDisplayString(_ctx.lenU), 9, _hoisted_116)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_ctx.svgCategory === 'ONEPIECE')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_117, [
                              _hoisted_118,
                              _createElementVNode("path", {
                                d: _ctx.onepieceSvgPath,
                                fill: "url(#dtOpGrad)",
                                stroke: "#c0608a",
                                "stroke-width": "2",
                                "stroke-linejoin": "round"
                              }, null, 8, _hoisted_119),
                              (_ctx.ms.total_length)
                                ? (_openBlock(), _createElementBlock("g", _hoisted_120, [
                                    _createElementVNode("line", {
                                      x1: _ctx.opCoords.leftEdge - 20,
                                      y1: _ctx.opCoords.topY,
                                      x2: _ctx.opCoords.leftEdge - 20,
                                      y2: _ctx.opCoords.bottomY,
                                      stroke: "#888",
                                      "stroke-width": "0.8",
                                      "stroke-dasharray": "4,2"
                                    }, null, 8, _hoisted_121),
                                    _createElementVNode("line", {
                                      x1: _ctx.opCoords.leftEdge - 24,
                                      y1: _ctx.opCoords.topY,
                                      x2: _ctx.opCoords.leftEdge - 16,
                                      y2: _ctx.opCoords.topY,
                                      stroke: "#888",
                                      "stroke-width": "1"
                                    }, null, 8, _hoisted_122),
                                    _createElementVNode("line", {
                                      x1: _ctx.opCoords.leftEdge - 24,
                                      y1: _ctx.opCoords.bottomY,
                                      x2: _ctx.opCoords.leftEdge - 16,
                                      y2: _ctx.opCoords.bottomY,
                                      stroke: "#888",
                                      "stroke-width": "1"
                                    }, null, 8, _hoisted_123),
                                    _createElementVNode("rect", {
                                      x: _ctx.opCoords.leftEdge - 50,
                                      y: (_ctx.opCoords.topY + _ctx.opCoords.bottomY) / 2 - 8,
                                      width: "56",
                                      height: "16",
                                      rx: "3",
                                      fill: "#fff",
                                      stroke: "#ddd",
                                      "stroke-width": "0.5"
                                    }, null, 8, _hoisted_124),
                                    _createElementVNode("text", {
                                      x: _ctx.opCoords.leftEdge - 22,
                                      y: (_ctx.opCoords.topY + _ctx.opCoords.bottomY) / 2 + 4,
                                      "text-anchor": "middle",
                                      class: "svg-measure-label"
                                    }, "총장 " + _toDisplayString(_ctx.dcm(_ctx.ms.total_length)) + _toDisplayString(_ctx.lenU), 9, _hoisted_125)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.ms.shoulder_width)
                                ? (_openBlock(), _createElementBlock("g", _hoisted_126, [
                                    _createElementVNode("line", {
                                      x1: _ctx.opCoords.shoulderL,
                                      y1: _ctx.opCoords.topY - 14,
                                      x2: _ctx.opCoords.shoulderR,
                                      y2: _ctx.opCoords.topY - 14,
                                      stroke: "#e74c3c",
                                      "stroke-width": "0.8",
                                      "stroke-dasharray": "4,2"
                                    }, null, 8, _hoisted_127),
                                    _createElementVNode("line", {
                                      x1: _ctx.opCoords.shoulderL,
                                      y1: _ctx.opCoords.topY - 18,
                                      x2: _ctx.opCoords.shoulderL,
                                      y2: _ctx.opCoords.topY - 10,
                                      stroke: "#e74c3c",
                                      "stroke-width": "1"
                                    }, null, 8, _hoisted_128),
                                    _createElementVNode("line", {
                                      x1: _ctx.opCoords.shoulderR,
                                      y1: _ctx.opCoords.topY - 18,
                                      x2: _ctx.opCoords.shoulderR,
                                      y2: _ctx.opCoords.topY - 10,
                                      stroke: "#e74c3c",
                                      "stroke-width": "1"
                                    }, null, 8, _hoisted_129),
                                    _createElementVNode("rect", {
                                      x: 150 - 34,
                                      y: _ctx.opCoords.topY - 32,
                                      width: "68",
                                      height: "16",
                                      rx: "3",
                                      fill: "#fff",
                                      stroke: "#f0c0c0",
                                      "stroke-width": "0.5"
                                    }, null, 8, _hoisted_130),
                                    _createElementVNode("text", {
                                      x: "150",
                                      y: _ctx.opCoords.topY - 21,
                                      "text-anchor": "middle",
                                      class: "svg-measure-label red"
                                    }, "어깨 " + _toDisplayString(_ctx.dcm(_ctx.ms.shoulder_width)) + _toDisplayString(_ctx.lenU), 9, _hoisted_131)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.ms.chest_width)
                                ? (_openBlock(), _createElementBlock("g", _hoisted_132, [
                                    _createElementVNode("line", {
                                      x1: _ctx.opCoords.chestL,
                                      y1: _ctx.opCoords.chestY,
                                      x2: _ctx.opCoords.chestR,
                                      y2: _ctx.opCoords.chestY,
                                      stroke: "#e74c3c",
                                      "stroke-width": "0.8",
                                      "stroke-dasharray": "4,2"
                                    }, null, 8, _hoisted_133),
                                    _createElementVNode("rect", {
                                      x: _ctx.opCoords.chestR + 6,
                                      y: _ctx.opCoords.chestY - 8,
                                      width: "68",
                                      height: "16",
                                      rx: "3",
                                      fill: "#fff",
                                      stroke: "#f0c0c0",
                                      "stroke-width": "0.5"
                                    }, null, 8, _hoisted_134),
                                    _createElementVNode("text", {
                                      x: _ctx.opCoords.chestR + 40,
                                      y: _ctx.opCoords.chestY + 4,
                                      "text-anchor": "middle",
                                      class: "svg-measure-label red"
                                    }, "가슴 " + _toDisplayString(_ctx.dcm(_ctx.ms.chest_width)) + _toDisplayString(_ctx.lenU), 9, _hoisted_135)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.ms.waist_width)
                                ? (_openBlock(), _createElementBlock("g", _hoisted_136, [
                                    _createElementVNode("line", {
                                      x1: _ctx.opCoords.waistL,
                                      y1: _ctx.opCoords.waistY,
                                      x2: _ctx.opCoords.waistR,
                                      y2: _ctx.opCoords.waistY,
                                      stroke: "#3498db",
                                      "stroke-width": "0.8",
                                      "stroke-dasharray": "4,2"
                                    }, null, 8, _hoisted_137),
                                    _createElementVNode("rect", {
                                      x: _ctx.opCoords.waistR + 6,
                                      y: _ctx.opCoords.waistY - 8,
                                      width: "68",
                                      height: "16",
                                      rx: "3",
                                      fill: "#fff",
                                      stroke: "#c0d8f0",
                                      "stroke-width": "0.5"
                                    }, null, 8, _hoisted_138),
                                    _createElementVNode("text", {
                                      x: _ctx.opCoords.waistR + 40,
                                      y: _ctx.opCoords.waistY + 4,
                                      "text-anchor": "middle",
                                      class: "svg-measure-label blue"
                                    }, "허리 " + _toDisplayString(_ctx.dcm(_ctx.ms.waist_width)) + _toDisplayString(_ctx.lenU), 9, _hoisted_139)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.ms.hip_width)
                                ? (_openBlock(), _createElementBlock("g", _hoisted_140, [
                                    _createElementVNode("line", {
                                      x1: _ctx.opCoords.hipL,
                                      y1: _ctx.opCoords.hipY,
                                      x2: _ctx.opCoords.hipR,
                                      y2: _ctx.opCoords.hipY,
                                      stroke: "#27ae60",
                                      "stroke-width": "0.8",
                                      "stroke-dasharray": "4,2"
                                    }, null, 8, _hoisted_141),
                                    _createElementVNode("rect", {
                                      x: _ctx.opCoords.hipR + 6,
                                      y: _ctx.opCoords.hipY - 8,
                                      width: "72",
                                      height: "16",
                                      rx: "3",
                                      fill: "#fff",
                                      stroke: "#b0d8b0",
                                      "stroke-width": "0.5"
                                    }, null, 8, _hoisted_142),
                                    _createElementVNode("text", {
                                      x: _ctx.opCoords.hipR + 42,
                                      y: _ctx.opCoords.hipY + 4,
                                      "text-anchor": "middle",
                                      class: "svg-measure-label green"
                                    }, "엉덩이 " + _toDisplayString(_ctx.dcm(_ctx.ms.hip_width)) + _toDisplayString(_ctx.lenU), 9, _hoisted_143)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.ms.sleeve_length)
                                ? (_openBlock(), _createElementBlock("g", _hoisted_144, [
                                    _createElementVNode("line", {
                                      x1: _ctx.opCoords.shoulderR,
                                      y1: _ctx.opCoords.topY,
                                      x2: _ctx.opCoords.sleeveEndX,
                                      y2: _ctx.opCoords.sleeveEndY,
                                      stroke: "#3498db",
                                      "stroke-width": "0.8",
                                      "stroke-dasharray": "4,2"
                                    }, null, 8, _hoisted_145),
                                    _createElementVNode("rect", {
                                      x: _ctx.opCoords.sleeveEndX - 4,
                                      y: _ctx.opCoords.sleeveEndY + 4,
                                      width: "68",
                                      height: "16",
                                      rx: "3",
                                      fill: "#fff",
                                      stroke: "#c0d8f0",
                                      "stroke-width": "0.5"
                                    }, null, 8, _hoisted_146),
                                    _createElementVNode("text", {
                                      x: _ctx.opCoords.sleeveEndX + 30,
                                      y: _ctx.opCoords.sleeveEndY + 16,
                                      "text-anchor": "middle",
                                      class: "svg-measure-label blue"
                                    }, "소매 " + _toDisplayString(_ctx.dcm(_ctx.ms.sleeve_length)) + _toDisplayString(_ctx.lenU), 9, _hoisted_147)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_ctx.svgCategory === 'SHOES')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_148, [
                                _hoisted_149,
                                _createElementVNode("path", {
                                  d: _ctx.shoesSvgPath,
                                  fill: "url(#dtShoeGrad)",
                                  stroke: "#8a7560",
                                  "stroke-width": "2",
                                  "stroke-linejoin": "round"
                                }, null, 8, _hoisted_150),
                                (_ctx.ms.foot_length)
                                  ? (_openBlock(), _createElementBlock("g", _hoisted_151, [
                                      _createElementVNode("line", {
                                        x1: _ctx.shoeCoords.toeX,
                                        y1: _ctx.shoeCoords.bottomY + 16,
                                        x2: _ctx.shoeCoords.heelX,
                                        y2: _ctx.shoeCoords.bottomY + 16,
                                        stroke: "#888",
                                        "stroke-width": "0.8",
                                        "stroke-dasharray": "4,2"
                                      }, null, 8, _hoisted_152),
                                      _createElementVNode("line", {
                                        x1: _ctx.shoeCoords.toeX,
                                        y1: _ctx.shoeCoords.bottomY + 12,
                                        x2: _ctx.shoeCoords.toeX,
                                        y2: _ctx.shoeCoords.bottomY + 20,
                                        stroke: "#888",
                                        "stroke-width": "1"
                                      }, null, 8, _hoisted_153),
                                      _createElementVNode("line", {
                                        x1: _ctx.shoeCoords.heelX,
                                        y1: _ctx.shoeCoords.bottomY + 12,
                                        x2: _ctx.shoeCoords.heelX,
                                        y2: _ctx.shoeCoords.bottomY + 20,
                                        stroke: "#888",
                                        "stroke-width": "1"
                                      }, null, 8, _hoisted_154),
                                      _createElementVNode("rect", {
                                        x: (_ctx.shoeCoords.toeX + _ctx.shoeCoords.heelX) / 2 - 34,
                                        y: _ctx.shoeCoords.bottomY + 22,
                                        width: "68",
                                        height: "16",
                                        rx: "3",
                                        fill: "#fff",
                                        stroke: "#ddd",
                                        "stroke-width": "0.5"
                                      }, null, 8, _hoisted_155),
                                      _createElementVNode("text", {
                                        x: (_ctx.shoeCoords.toeX + _ctx.shoeCoords.heelX) / 2,
                                        y: _ctx.shoeCoords.bottomY + 34,
                                        "text-anchor": "middle",
                                        class: "svg-measure-label"
                                      }, "발길이 " + _toDisplayString(_ctx.dmm(_ctx.ms.foot_length)) + _toDisplayString(_ctx.mmU), 9, _hoisted_156)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.ms.ball_width)
                                  ? (_openBlock(), _createElementBlock("g", _hoisted_157, [
                                      _createElementVNode("line", {
                                        x1: _ctx.shoeCoords.ballX,
                                        y1: _ctx.shoeCoords.ballTopY,
                                        x2: _ctx.shoeCoords.ballX,
                                        y2: _ctx.shoeCoords.bottomY,
                                        stroke: "#e74c3c",
                                        "stroke-width": "0.8",
                                        "stroke-dasharray": "4,2"
                                      }, null, 8, _hoisted_158),
                                      _createElementVNode("line", {
                                        x1: _ctx.shoeCoords.ballX - 4,
                                        y1: _ctx.shoeCoords.ballTopY,
                                        x2: _ctx.shoeCoords.ballX + 4,
                                        y2: _ctx.shoeCoords.ballTopY,
                                        stroke: "#e74c3c",
                                        "stroke-width": "1"
                                      }, null, 8, _hoisted_159),
                                      _createElementVNode("line", {
                                        x1: _ctx.shoeCoords.ballX - 4,
                                        y1: _ctx.shoeCoords.bottomY,
                                        x2: _ctx.shoeCoords.ballX + 4,
                                        y2: _ctx.shoeCoords.bottomY,
                                        stroke: "#e74c3c",
                                        "stroke-width": "1"
                                      }, null, 8, _hoisted_160),
                                      _createElementVNode("rect", {
                                        x: _ctx.shoeCoords.ballX + 8,
                                        y: (_ctx.shoeCoords.ballTopY + _ctx.shoeCoords.bottomY) / 2 - 8,
                                        width: "68",
                                        height: "16",
                                        rx: "3",
                                        fill: "#fff",
                                        stroke: "#f0c0c0",
                                        "stroke-width": "0.5"
                                      }, null, 8, _hoisted_161),
                                      _createElementVNode("text", {
                                        x: _ctx.shoeCoords.ballX + 42,
                                        y: (_ctx.shoeCoords.ballTopY + _ctx.shoeCoords.bottomY) / 2 + 4,
                                        "text-anchor": "middle",
                                        class: "svg-measure-label red"
                                      }, "발볼 " + _toDisplayString(_ctx.dmm(_ctx.ms.ball_width)) + _toDisplayString(_ctx.mmU), 9, _hoisted_162)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_163, "불러오는 중..."))
  ]))
}